import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { HttpModule } from "./services/http.module";
import { EnterGuard } from "./services/enterGuard";

const routes: Routes = [
  // { path: '', redirectTo: 'page-tabs', pathMatch: 'full'},
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", loadChildren: "./pages/login/login.module#LoginPageModule" },
  { path: "page", loadChildren: "./tabs/tabs.module#TabsPageModule" },
  {
    path: "page-tabs",
    loadChildren: "./temporary-tabs/temporary-tabs.module#TemporaryTabsModule",
  },

  // { path: '', loadChildren: './pages/login/login.module#LoginPageModule' },
  // { path: '', loadChildren: './temporary-tabs/temporary-tabs.module#TemporaryTabsModule' },
  {
    path: "forget-password",
    loadChildren:
      "./pages/forget-password/forget-password.module#ForgetPasswordModule",
  },
  {
    path: "duty-detail",
    loadChildren:
      "./pages/tab1/duty-detail/duty-detail.module#DutyDetailModule",
  },
  { path: "passport", loadChildren: "./pages/tab4/tab4.module#Tab4Module" },
  // ,canActivate: [EnterGuard]
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
  providers: [EnterGuard, HttpModule],
  entryComponents: [],
})
export class AppRoutingModule {}
